// extracted by mini-css-extract-plugin
module.exports = {"root":"FxgzMBXG","flexColumn":"B8vDD5YX","titleLabel":"WWpaoIH9","pdfIcon":"qNydu3Bq","skeletonLoaderWrapper":"uF0p8QHc","rowWrapper":"A7J4wlSP"};